module.exports = __webpack_public_path__ + "static/img/new_program_03.be7dfbff.jpg";